import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certifications from './components/Certifications';
import Education from './components/Education';
import Footer from './components/Footer';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <Header />
        <main>
          <Hero />
          <About />
          <Experience />
          <Projects />
          <Skills />
          <Certifications />
          <Education />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;

